import { useEffect, useState } from "react";
import CertificateCard from "./CertificateCard";
import { FiAward } from "react-icons/fi";

function Certificates() {
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    fetch("/data/certificatesData.json")
      .then(response => response.json())
      .then(setCertificates)
      .catch(() => setCertificates([]));
  }, []);

  return (
    <section id="certificates" className="section-shell">
      <div className="section-heading">
        <p className="section-title">Certificates</p>
        <span className="section-icon" aria-hidden="true"><FiAward /></span>
      </div>

      <div className="certificate-grid">
        {certificates.map((certificate, index) => (
          <CertificateCard key={certificate.title || index} props={certificate} />
        ))}
      </div>
    </section>
  );
}

export default Certificates;
